import { render } from "./stack_client_r_set_B.vue?vue&type=template&id=467e954d&scoped=true"
import script from "./stack_client_r_set_B.vue?vue&type=script&lang=js"
export * from "./stack_client_r_set_B.vue?vue&type=script&lang=js"

import "./stack_client_r_set_B.vue?vue&type=style&index=0&id=467e954d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467e954d"]])

export default __exports__